// extracted by mini-css-extract-plugin
export default {"container":"LKbQ","title":"xyHB","quantity":"grop","btn":"lObC"};